import React from "react";
import { inputStyle } from "../UI";

export const JOB_BOARDS = [
  { id: "linkedin", label: "LinkedIn", color: "#0A66C2", primary: true, blurb: "Post first. Open LinkedIn Jobs, then continue to Indeed." },
  { id: "indeed", label: "Indeed", color: "#2164F3", primary: true, blurb: "Post second, after LinkedIn. Same job details." },
  { id: "naukri", label: "Naukri", color: "#0B5CAB", needsInterest: true, blurb: "Optional. We ask if you are interested first." },
  { id: "foundit", label: "Foundit (Formdin)", color: "#6C5CE7", needsInterest: true, blurb: "Optional. Confirm interest before we open Foundit." },
  { id: "glassdoor", label: "Glassdoor", color: "#00A264", needsInterest: true, blurb: "Optional. We ask if you are interested first." }
];

export const BOARD_POST_ORDER = ["linkedin", "indeed", "naukri", "foundit", "glassdoor"];
export const PRIMARY_JOB_BOARDS = ["linkedin", "indeed"];

export const EMPTY_JOB_FORM = {
  role: "",
  skills: "",
  experience: "",
  salary_range: "",
  description: "",
  location: "",
  employment_type: "Full-time",
  openings: "1",
  platforms: [...PRIMARY_JOB_BOARDS],
  hiring_request_id: ""
};

export function boardComposerUrl(platform) {
  if (platform === "linkedin") return "https://www.linkedin.com/job-posting/";
  if (platform === "indeed") return "https://www.indeed.com/hire/post-job";
  if (platform === "naukri") return "https://hiring.naukri.com/";
  if (platform === "foundit") return "https://recruiter.foundit.in/";
  if (platform === "glassdoor") return "https://www.glassdoor.com/employers/post-job.htm";
  return "";
}

export function boardPastePlaceholder(platform) {
  if (platform === "linkedin") return "Paste LinkedIn job URL https://www.linkedin.com/jobs/view/...";
  if (platform === "indeed") return "Paste Indeed job URL https://in.indeed.com/viewjob?jk=...";
  if (platform === "naukri") return "Paste Naukri job URL";
  if (platform === "foundit") return "Paste Foundit job URL";
  if (platform === "glassdoor") return "Paste Glassdoor job URL";
  return "Paste live job URL";
}

export function boardInterestCopy(board) {
  const name = board?.label || "this board";
  if (board?.id === "foundit") {
    return {
      title: "Are you interested in Foundit (Formdin)?",
      body: "Foundit is optional. If you are interested, WIBIL will open the Foundit recruiter page after you post — the same flow as Indeed. If you are not interested, Foundit stays off and we will not open it."
    };
  }
  return {
    title: `Are you interested in ${name}?`,
    body: `${name} is optional. Choose Yes only if you want WIBIL to open ${name} after you post this job. Choose Not interested to skip it.`
  };
}

export function validateJobDetails(form) {
  const errors = {};
  const role = String(form.role || "").trim();
  const description = String(form.description || "").trim();
  const skills = String(form.skills || "").trim();
  const experience = String(form.experience || "").trim();
  const location = String(form.location || "").trim();
  const salary = String(form.salary_range || "").trim();
  const openings = Number(form.openings);
  if (role.length < 3) errors.role = "Enter a job title, for example Full Stack Developer.";
  if (description.length < 40) errors.description = "Add a job description of at least 40 characters (summary, responsibilities, must-have skills).";
  if (!skills) errors.skills = "Enter at least one skill, separated by commas.";
  if (!experience) errors.experience = "Enter the experience required, for example 2-5 years.";
  if (!salary) errors.salary_range = "Enter a salary range, for example Rs. 8,00,000 - 12,00,000.";
  if (!location) errors.location = "Enter a job location, for example Chennai, Tamil Nadu.";
  if (!Number.isFinite(openings) || openings < 1) errors.openings = "Enter at least 1 opening.";
  return errors;
}

export function orderedSelectedBoards(platforms) {
  const selected = new Set((platforms || []).filter(Boolean));
  return BOARD_POST_ORDER.filter((id) => selected.has(id));
}

export function boardLabel(id) {
  return JOB_BOARDS.find((b) => b.id === id)?.label || id;
}

export function validateJobBoards(form) {
  const platforms = Array.isArray(form.platforms) ? form.platforms.filter(Boolean) : [];
  if (!platforms.length) return { platforms: "Choose at least one job board. LinkedIn first, then Indeed." };
  return {};
}

export function jobInputStyle(theme, hasError) {
  return {
    ...inputStyle(theme),
    border: `1px solid ${hasError ? "#dc2626" : theme.line}`,
    boxShadow: hasError ? "0 0 0 3px rgba(220,38,38,0.12)" : "none"
  };
}

export function FieldError({ message }) {
  if (!message) return null;
  return <div style={{ color: "#dc2626", fontSize: 12, fontWeight: 600, marginTop: 6 }}>{message}</div>;
}

export function isPostedOnBoard(post) {
  const url = String(post.externalUrl || post.external_url || "").toLowerCase();
  const id = post.id || post.platform;
  if (post.status !== "posted") return false;
  if (id === "linkedin") return url.includes("linkedin.com");
  if (id === "naukri") return url.includes("naukri.com");
  if (id === "indeed") return url.includes("indeed.");
  if (id === "foundit") return url.includes("foundit") || url.includes("monster");
  if (id === "glassdoor") return url.includes("glassdoor.") || url.includes("indeed.");
  return false;
}
